import {combineReducers} from 'redux';

import authReducer from './auth/auth.reducers';
import addressesReducer from './addresses/addresses.reducers';
import accountsReducer from './accounts/accounts.reducers';
import jobsReducer from './jobs/jobs.reducers';
import referencesReducer from './references/references.reducers';
import listsReducer from './lists/lists.reducers';
import clientsReducers from './clients/clients.reducers';
import relationsReducers from './relations/relations.reducers';
import pepReducer from './pep/pep.reducers';
import fatcaReducer from './fatca/fatca.reducers';
import optionsReducer from './options/options.reducers';
import formsReducer from './forms/forms.reducers';
import calendarReducer from './calendar/calendar.reducers';
import otpReducer from './otp/otp.reducers';

const rootReducer = combineReducers({
  auth: authReducer,
  addresses: addressesReducer,
  accounts: accountsReducer,
  jobs: jobsReducer,
  references: referencesReducer,
  lists: listsReducer,
  clients: clientsReducers,
  relations: relationsReducers,
  pep: pepReducer,
  fatca: fatcaReducer,
  options: optionsReducer,
  forms: formsReducer,
  calendar: calendarReducer,
  otp: otpReducer
});

export default rootReducer;
